import Div from "@jumbo/shared/Div";
import {
  Box,
  Button,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import RawMaterialFilter from "../FilterComponent/rawMaterialFilter";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import FinishedGoodsFilter from "../FilterComponent/finishedGoodsFilter";
import ProductionFilter from "../FilterComponent/productionFilter";
import WastageFilter from "../FilterComponent/wastageFilter";
import RawMaterialTable from "../TableComponent/RawMaterialTable";
import FinishedGoodsTable from "../TableComponent/FinishedGoodsTable";
import ProductionTable from "../TableComponent/ProductionTable";
import WastageTable from "../TableComponent/WastageTable";
import AddonsFilter from "../FilterComponent/addonsFilter";
import {
  fetchFactoryInventory,
  fetchFinishedOrdersScrapInventory,
  fetchRawOrdersScrapInventory,
  getAllAddonsInventory,
  getAllFinishedGoods,
  getAllFinishedScrapped,
  getAllProduction,
  getAllProductionHistory,
  getAllRawMaterial,
  getAllRawScrapped,
  getAllWastage,
  getFinishedManuallyIssued,
  getRawMaterialManuallyIssued,
} from "app/redux/actions/inventoryAction";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import FactoryAddOnsTable from "../TableComponent/FactoryAddOnsTable";
import RawManuallyIssuedTable from "../TableComponent/RawManuallyIssuedTable";
import RawIssuedFilter from "../FilterComponent/rawIssuedFilter";
import FinishedManuallyIssuedTable from "../TableComponent/FinishedManuallyIssuedTable";
import FinishedIssuedFilter from "../FilterComponent/finishedIssuedFIlter";
import ProductionHistoryFilter from "../FilterComponent/productionHistoryFilter";
import ProductionHistoryTable from "../TableComponent/ProductionHistoryTable";
import RawScrappedFilter from "../FilterComponent/RawScrappedFilter";
import FinishedScrappedFilter from "../FilterComponent/FinishedScrappedFilter";
import FinishedScrappedTable from "../TableComponent/FinishedScrappedTable";
import RawScrappedTable from "../TableComponent/RawScrappedTable";
import FactoryInventoryTable from "../TableComponent/FactoryInventoryTable";
import FactoryInventoryFilter from "../FilterComponent/FactoryFilter";
import OrdersRawScrapTable from "../TableComponent/OrdersRawScrapTable";
import OrderFinishedScrapTable from "../TableComponent/OrderFinishedScrapTable";
import OrdersRawScrapFilter from "../FilterComponent/OrdersRawScrapFilter";
import OrderFinishedScrapFilter from "../FilterComponent/OrdersFinsihedScrapFilter";
import EditInvoice from "../EditInvoice";

const InventoryList = () => {
  const [nav, setNav] = useState("Raw Material");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [value, setValue] = React.useState(0);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const [editInvoiceOpen, setEditInvoiceOpen] = useState(false)
  const [inputsWastage, setInputsWastage] = useState({});
  const [inputsRawScrap, setInputsRawScrap] = useState({});
  const [inputsProduction, setInputsProduction] = useState({});
  const [inputsProductionHistory, setInputsProductionHistory] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSearch = (value) => {
    let searchValue = value;
    if (!value) {
      searchValue = value
    }
    if (nav === "Raw Material") {
      dispatch(getAllRawMaterial(searchValue, ""));
    } else if (nav === "Finished Goods") {
      dispatch(getAllFinishedGoods(searchValue, ""));
    } else if (nav === "Production") {
      dispatch(getAllProduction(searchValue, inputsProduction, 1));
    } else if (nav === "Raw Scrapped") {
      dispatch(getAllRawScrapped(searchValue, inputsRawScrap, 1));
    } else if (nav === "Finished Scrapped") {
      dispatch(getAllFinishedScrapped(searchValue, ""));
    } else if (nav === "Wastage") {
      dispatch(getAllWastage(searchValue, inputsWastage, 1));
    } else if (nav === "Factory AddOns") {
      dispatch(getAllAddonsInventory(searchValue, ""));
    } else if (nav === "Raw Manually Issued") {
      dispatch(getRawMaterialManuallyIssued(searchValue, ""));
    } else if (nav === "Finished Manually Issued") {
      dispatch(getFinishedManuallyIssued(searchValue, ""));
    } else if (nav === "Production History") {
      dispatch(getAllProductionHistory(searchValue, inputsProductionHistory, 1));
    } else if (nav === "Factory Inventory") {
      dispatch(fetchFactoryInventory(searchValue, ""));
    } else if (nav === "Orders Raw Scrapped") {
      dispatch(fetchRawOrdersScrapInventory(searchValue, ""));
    } else if (nav === "Orders Finished Scrapped") {
      dispatch(fetchFinishedOrdersScrapInventory(searchValue, ""));
    }
  };

  // navs and tab functionality
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchTerm("")
    setPage(1)
  };

  useEffect(() => {
    // console.log(nav);
    nav === "Raw Material" && dispatch(getAllRawMaterial("", "", 1));
    nav === "Finished Goods" && dispatch(getAllFinishedGoods("", "", 1));
    nav === "Production" && dispatch(getAllProduction("", "", 1));
    nav === "Wastage" && dispatch(getAllWastage("", "", page));
    nav === "Factory AddOns" && dispatch(getAllAddonsInventory("", "", 1));
    nav === "Finished Scrapped" && dispatch(getAllFinishedScrapped("", "", 1));
    nav === "Raw Scrapped" && dispatch(getAllRawScrapped("", "", page));
    nav === "Raw Manually Issued" &&
      dispatch(getRawMaterialManuallyIssued("", "", 1));
    nav === "Finished Manually Issued" &&
      dispatch(getFinishedManuallyIssued("", "", 1));
    nav === "Production History" && dispatch(getAllProductionHistory("", "", page));
    nav === "Factory Inventory" && dispatch(fetchFactoryInventory("", "", 1));
    nav === "Orders Raw Scrapped" && dispatch(fetchRawOrdersScrapInventory("", "", 1));
    nav === "Orders Finished Scrapped" && dispatch(fetchFinishedOrdersScrapInventory("", "", 1));
  }, [nav]);

  return (
    <>
      <Typography variant="h1" sx={{ mt: -4 }}>
        Inventory
      </Typography>
      {nav === "Raw Material" && <RawMaterialFilter />}
      {nav === "Finished Goods" && <FinishedGoodsFilter />}
      {nav === "Production" && <ProductionFilter
        setInputsProduction={setInputsProduction}
        search={searchTerm}
        setPage={setPage}
      />}
      {nav === "Raw Scrapped" && <RawScrappedFilter
        setInputsRawScrap={setInputsRawScrap}
        search={searchTerm}
        setPage={setPage}
      />}
      {nav === "Finished Scrapped" && <FinishedScrappedFilter />}
      {nav === "Wastage" && <WastageFilter
        setInputsWastage={setInputsWastage}
        search={searchTerm}
        setPage={setPage}
      />}
      {nav === "Factory AddOns" && <AddonsFilter />}
      {nav === "Raw Manually Issued" && <RawIssuedFilter />}
      {nav === "Finished Manually Issued" && <FinishedIssuedFilter />}
      {nav === "Production History" && <ProductionHistoryFilter
        setInputsProductionHistory={setInputsProductionHistory}
        search={searchTerm}
        setPage={setPage}
      />}
      {nav === "Factory Inventory" && <FactoryInventoryFilter />}
      {nav === "Orders Raw Scrapped" && <OrdersRawScrapFilter />}
      {nav === "Orders Finished Scrapped" && <OrderFinishedScrapFilter />}
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            handleSearch(e.target.value);
            setPage(1)
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        <Div sx={{ display: "flex", gap: 2 }}>
          {permissions?.inventory_edit === true && (
            <Div >
              <Button variant='contained' onClick={() => setEditInvoiceOpen(true)}>
                Edit Invoice
              </Button>
              {editInvoiceOpen && <EditInvoice open={editInvoiceOpen} setOpen={setEditInvoiceOpen} />}
            </Div>
          )}
          {permissions?.inventory_create === true && (

            <Div >
              {nav !== "Factory Inventory" && (
                <Button
                  variant="contained"
                  onClick={() => navigate("/dashboard/inventory/add")}
                >
                  Add Stock
                </Button>
              )}

            </Div>
          )}
        </Div>
      </Div >
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label="Raw Material"
              {...a11yProps(0)}
              onClick={() => setNav("Raw Material")}
            />
            <Tab
              label="Finished Good"
              {...a11yProps(1)}
              onClick={() => setNav("Finished Goods")}
            />
            <Tab
              label="Production"
              {...a11yProps(2)}
              onClick={() => setNav("Production")}
            />
            <Tab
              label="Wastage"
              {...a11yProps(3)}
              onClick={() => setNav("Wastage")}
            />
            <Tab
              label="Factory AddOns"
              {...a11yProps(4)}
              onClick={() => setNav("Factory AddOns")}
            />
            <Tab
              label="Raw Manually Issued"
              {...a11yProps(5)}
              onClick={() => setNav("Raw Manually Issued")}
            />
            <Tab
              label="Finished Manually Issued"
              {...a11yProps(6)}
              onClick={() => setNav("Finished Manually Issued")}
            />
            <Tab
              label="Production History"
              {...a11yProps(7)}
              onClick={() => setNav("Production History")}
            />
            <Tab
              label="Raw Scrapped"
              {...a11yProps(8)}
              onClick={() => setNav("Raw Scrapped")}
            />
            <Tab
              label="Finished Scrapped"
              {...a11yProps(9)}
              onClick={() => setNav("Finished Scrapped")}
            />
            <Tab
              label="Factory Inventory"
              {...a11yProps(10)}
              onClick={() => setNav("Factory Inventory")}
            />
            <Tab
              label="Orders Raw Scrapped"
              {...a11yProps(11)}
              onClick={() => setNav("Orders Raw Scrapped")}
            />
            <Tab
              label="Orders Finished Scrapped"
              {...a11yProps(12)}
              onClick={() => setNav("Orders Finished Scrapped")}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <RawMaterialTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FinishedGoodsTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <ProductionTable
            searchTerm={searchTerm}
            filter={inputsProduction}
            page={page}
            setPage={setPage}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <WastageTable
            searchTerm={searchTerm}
            filter={inputsWastage}
            page={page}
            setPage={setPage}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <FactoryAddOnsTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          <RawManuallyIssuedTable searchTerm={searchTerm} />
        </CustomTabPanel>
        {/* new table for order raw scrap listing */}

        <CustomTabPanel value={value} index={6}>
          <FinishedManuallyIssuedTable searchTerm={searchTerm} />
        </CustomTabPanel>


        <CustomTabPanel value={value} index={7}>
          <ProductionHistoryTable
            searchTerm={searchTerm}
            filter={inputsProductionHistory}
            page={page}
            setPage={setPage}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={8}>
          <RawScrappedTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={9}>
          <FinishedScrappedTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={10}>
          <FactoryInventoryTable searchTerm={searchTerm} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={11}>
          <OrdersRawScrapTable
            searchTerm={searchTerm}
            filter={inputsRawScrap}
            page={page}
            setPage={setPage}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={12}>
          <OrderFinishedScrapTable searchTerm={searchTerm} />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default InventoryList;
